import { AccountingBalance } from "../../../../../store/types/applicationBank.type";

export type BalanceRows = Record<string, { lc: number }>;

export const getFormattedBalanceData = (financeData?: AccountingBalance) => {
  const res: BalanceRows = {};

  financeData?.data.active.forEach((el) => {
    if (el.code) {
      res[el.code] = { lc: el.lc };
    }
  });
  financeData?.data.passive.forEach((el) => {
    if (el.code) {
      res[el.code] = { lc: el.lc };
    }
  });
  financeData?.data.report.forEach((el) => {
    if (el.code) {
      res[el.code] = { lc: el.lc };
    }
  });

  return res;
};
